(function(){
 'use strict';
 var root=document.getElementById('MRAnalyticsConfig');
 if(!root||window.MRAnalyticsInstalled)return;
 window.MRAnalyticsInstalled=true;
 var config;try{config=JSON.parse(root.textContent)}catch(e){return}
 if(config.measurementId!=='G-R7JD0LEP7S'||config.live!==true){root.dataset.state='preview-disabled';return}
 var id=config.measurementId,started=false,permitted=false,requested=false,pageSent=false;
 var deny={analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'};
 var pageTypes=['index','product','collection','page','search'];
 var pageType=pageTypes.indexOf(config.pageType)>=0?config.pageType:'other';
 var pagePath=/^\/(products|collections|pages)\/[a-zA-Z0-9_-]+$/.test(config.pagePath)?config.pagePath:config.pagePath==='/search'?'/search':'/';
 var pageLocation=location.origin+pagePath;
 var referrer='';try{var ref=new URL(document.referrer);if(/^https?:$/.test(ref.protocol))referrer=ref.origin+'/'}catch(e){}
 var query=new URLSearchParams(location.search);
 var source=query.get('utm_source')||'';source=['linkedin','google','bing','facebook','instagram','email','whatsapp'].indexOf(source)>=0?source:'';
 var medium=query.get('utm_medium')||'';medium=['social','organic','referral','email','cpc'].indexOf(medium)>=0?medium:'';
 var settings={send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:pageLocation,page_referrer:referrer,page_title:config.pageTitle||'MR Solutions',campaign_id:'(not set)',campaign_name:'(not set)',campaign_content:'(not set)',campaign_term:'(not set)',cookie_flags:'SameSite=Lax;Secure'};
 if(source){settings.campaign_source=source;settings.campaign_medium=medium||'referral'}
 else if(query.has('utm_source')||query.has('utm_medium')){settings.campaign_source='(direct)';settings.campaign_medium='(none)'}
 var campaign=query.get('utm_campaign')||'';
 var content=query.get('utm_content')||'';
 if(source==='linkedin'&&medium==='social'&&campaign==='linkedin_organico_2026_11'){
  settings.campaign_name='linkedin_organico_2026_11';
  if(['pasa_en_campo_01','presentacion_mr'].indexOf(content)>=0)settings.campaign_content=content;
 }
 function allowed(){try{return !!(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.analyticsProcessingAllowed())}catch(e){return false}}
 function tag(){window.dataLayer.push(arguments)}
 function emit(name,extra){if(!permitted||!allowed()||!started)return;var params={send_to:id,page_type:pageType,page_location:pageLocation,page_referrer:referrer,page_title:settings.page_title};if(extra)params.click_source=extra;tag('event',name,params)}
 function start(){
  if(started)return;
  started=true;window.dataLayer=window.dataLayer||[];
  tag('consent','default',deny);
  tag('set','ads_data_redaction',true);tag('set','url_passthrough',false);
  tag('consent','update',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  tag('js',new Date());tag('config',id,settings);
  var script=document.createElement('script');script.async=true;script.id='MRGoogleTag';script.src='https://www.googletagmanager.com/gtag/js?id='+id;script.referrerPolicy='no-referrer';document.head.appendChild(script);
 }
 function applyConsent(){
  permitted=allowed();window['ga-disable-'+id]=!permitted;
  root.dataset.state=permitted?'consented':'consent-blocked';
  if(!permitted){if(started)tag('consent','update',deny);return}
  if(!started)start();else tag('consent','update',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  if(!pageSent){pageSent=true;emit('page_view')}
 }
 function connectPrivacy(){
  if(window.Shopify&&Shopify.customerPrivacy){applyConsent();return}
  if(!requested&&window.Shopify&&typeof Shopify.loadFeatures==='function'){
   requested=true;Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],function(error){if(!error)applyConsent()});
  }
 }
 document.addEventListener('visitorConsentCollected',applyConsent);
 document.addEventListener('DOMContentLoaded',connectPrivacy,{once:true});
 window.addEventListener('load',connectPrivacy,{once:true});
 document.addEventListener('click',function(event){
  var link=event.target&&event.target.closest?event.target.closest('a[href]'):null;
  if(!link||!permitted)return;
  var target;try{target=new URL(link.getAttribute('href'),location.origin)}catch(e){return}
  var isWhatsApp=target.protocol==='whatsapp:'||['wa.me','api.whatsapp.com','web.whatsapp.com','www.whatsapp.com'].indexOf(target.hostname)>=0;
  if(!isWhatsApp)return;
  var clickSource=link.closest('#MRQuotePanel')?'quote_list':pageType==='product'?'product':pageType==='index'?'home':'page';
  emit('quote_whatsapp_click',clickSource);
 },true);
 connectPrivacy();
})();
